import { useEffect, useState } from "react";
import { updateClientCode } from "@entrilia/shared/api/clientApiContext";
import type { ClientInfoExtended } from "../../../../../api/types/svTypes.ts";
import useClientContext from "../../../../../context/useClientContext.ts";
import useUserContext from "../../../../../context/useUserContext.ts";
import { getOrganizationClientCode } from "../../../../../utilities/clientHelper.ts";

export function useClientManagement() {
  const { clients } = useUserContext();
  const { clientCode } = useClientContext();
  const [clientInfo, setClientInfo] = useState<ClientInfoExtended>();

  useEffect(() => {
    if (clientCode !== undefined) {
      updateClientCode(clientCode);
    }
  }, [clientCode]);

  useEffect(() => {
    if (!clientCode) {
      return;
    }
    const org = getOrganizationClientCode(clientCode, clients);
    const info = clients.find((c) => c.clientCode === clientCode);
    if (info) {
      // TODO #209
      // eslint-disable-next-line @eslint-react/set-state-in-effect
      setClientInfo({ ...info, organization: org || "" });
    }
  }, [clients, clientCode]);

  return { clientInfo };
}
